import { Component, OnInit, Inject, Input, ViewChild, ElementRef } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { Options } from 'select2';
import { DialogData } from 'src/app/interfaces/interfaces';
import { SettingsProvider } from 'src/app/services/settings';
import { HttpClientProvider } from 'src/app/services/http-client';

declare var $: any;

import Swal from 'sweetalert2';

import { FormControl } from '@angular/forms';
import {COMMA, ENTER} from '@angular/cdk/keycodes';
import {map, startWith} from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { LoadingService } from 'src/app/services/loading.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-modal-addusers',
  templateUrl: './modal-addusers.component.html',
  styleUrls: ['./modal-addusers.component.scss']
})
export class ModalAddUsersComponent implements OnInit {

  public optionsSelect2: Options;

  users = null;
  user = null;
  type = null;

  separatorKeysCodes: number[] = [ENTER, COMMA];
  emailCtrl = new FormControl();
  filteredEmails: Observable<string[]>;
  emails: string[] = [];
  allEmails: string[] = [];

  @ViewChild('emailInput') emailInput: ElementRef<HTMLInputElement>;

  constructor(
    private http: HttpClientProvider,
    private load: LoadingService,
    private toast: NotificationService,
    public dialogRef: MatDialogRef<ModalAddUsersComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData
  ) {
    if(this.data.type == 'input') {
      this.load.loadingShow();
      this.http.getRequest(SettingsProvider.getUrl(`get-users`)).subscribe(result => {
        console.log(result);
        if(result['status']) {
          this.allEmails = result['items'];
          this.load.dismiss();
          setTimeout(()=>{
            this.filteredEmails = this.emailCtrl.valueChanges.pipe(
              startWith(null),
              map((email: string | null) => (email ? this._filter(email) : this.allEmails.slice())),
            );
          }, 1);
        } else {
          this.load.dismiss();
          this.toast.error('Error al obtener los datos', 'No se pudo obtener los datos, intente nuevamente.', 4000);
        }
      }, error => {
        console.log(error);
        this.load.dismiss();
        this.toast.error('Error al obtener los datos', 'No se pudo obtener los datos, verifíque su conexión a internet e intente nuevamente.', 4000);
      });
    } else {
      //
    }
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();
    if ((value || '').trim()) {
      if(!this.emails.includes(value.trim())&&this.validateEmail(event) /* &&this.allEmails.includes(value.trim()) */) {
        this.emails.push(value.trim());
      }
    }
    event.chipInput!.clear();
    this.emailCtrl.setValue(null);
  }

  validateEmail(input) {
    console.log(input);
    var validRegex = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    if (input.value.match(validRegex)) {
      // alert("Valid email address!");
      return true;
    } else {
      // alert("Invalid email address!");
      this.toast.error('Email Inválido', 'El Correo eletrónico introducido es incorrecto', 4000);
      return false;
    }
  }

  remove(email: string): void {
    const index = this.emails.indexOf(email);

    if (index >= 0) {
      this.emails.splice(index, 1);
    }
  }

  selected(event: MatAutocompleteSelectedEvent): void {
    if (!this.emails.includes(event.option.viewValue)) {
      this.emails.push(event.option.viewValue);
    }
    this.emailInput.nativeElement.value = '';
    this.emailCtrl.setValue(null);
  }

  private _filter(value: string): string[] {
    const filterValue = value.toLowerCase();
    let data = this.allEmails.filter(email => email.toLowerCase().includes(filterValue));
    return data;
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  accept() {
    this.data.dismiss_action = true;
    this.dialogRef.close({dismiss_action: this.data.dismiss_action});
  }

  ngOnInit() {

    this.optionsSelect2 = {
      multiple: true,
      theme: 'classic',
      closeOnSelect: false,
      // width: '300'
    };

  }

  submitForm() {
    this.load.loadingShow();
    if(this.data.type == 'input') {
      console.log(this.emails);
      this.http.postRequest(SettingsProvider.getUrl('create-request'), { function: 'createInviteUserRequest', params: this.emails }).subscribe(result => {
        console.log(result);
        if(result['status']) {
          if(result['message']){
            if(result['messages']&&result['messages'].length > 0&&result['errors']&&result['errors'].length > 0) {
              // console.log(result['messages']);
              this.load.dismiss();
              this.accept();
              this.toast.success(result['message'], result['messages'], 6000);
              this.toast.warning(result['message'], result['errors'], 10000);
            } else if(result['messages']&&result['messages'].length > 0){
              // console.log(result['messages'].length);
              this.load.dismiss();
              this.accept();
              this.toast.success(result['message'], result['messages'], 6000);
            } else if(result['errors']&&result['errors'].length > 0){
              // console.log(result['errors']);
              this.load.dismiss();
              this.accept();
              this.toast.warning(result['message'], result['errors'], 10000);
            } else {
              this.load.dismiss();
              this.accept();
              this.toast.success(result['message'], 'Se envió una solicitud al o los usuarios añadidos.', 6000);
            }
          } else {
            this.load.dismiss();
            this.toast.success('Acción ejecutada con éxito', 'Se envió una solicitud al o los usuarios añadidos.', 6000);
          }
        } else {
          this.load.dismiss();
          if(result['message']){
            if(result['errors']){
              this.toast.error(result['message'], result['errors'], 4000);
            } else {
              this.toast.error('Error al realizar la solicitud', result['message'], 4000);
            }
          } else {
            this.toast.error('Error al realizar la solicitud', 'Hubo un error al conectar con el servidor, intente nuevamente.', 4000);
          }
        }
      }, error => {
        console.log(error);
        this.load.dismiss();
        this.toast.error('Error al realizar la solicitud', 'Hubo un error al conectar con el servidor, verifique su conexión a internet e intente nuevamente.', 4000);
      });
    } else {
      console.log(this.users);
    }
  }

}
